import { $apiTelegram } from "Api";

const TELEGRAM_PATH = "/telega";
const CREATE_BLANK_PATH = "/createblank";
const SAVE_BLANK_PATH = "/saveblank";
const GET_ALL_USER_PATH = "/users";
const GET_ALL_WORK_PATH = "/works";
const GET_ALL_MATERIALS_WORK_PATH = "/materials";
const GET_SAVED_BLANKS_PATH = "/savedblanks";
const DELETE_SAVED_BLANK_PATH = "/deleteblank";
const GET_SINGLE_BLANK_TELEGRAM_PATH = "/getsingle";

class TelegramApi {
  createBlank = async (data) => {
    return await $apiTelegram.post(TELEGRAM_PATH + CREATE_BLANK_PATH, {
      ...data,
    });
  };
  saveBlank = async (data) => {
    return await $apiTelegram.post(TELEGRAM_PATH + SAVE_BLANK_PATH, {
      ...data,
    });
  };
  getSavedBlanksForProject = async (projectId) => {
    return await $apiTelegram.get(
      TELEGRAM_PATH + GET_SAVED_BLANKS_PATH + `?projectId=${projectId}`,
    );
  };
  deleteSavedBlankForProject = async (blankId, projectId) => {
    return await $apiTelegram.delete(
      TELEGRAM_PATH +
        DELETE_SAVED_BLANK_PATH +
        `?blankId=${blankId}&projectId=${projectId}`,
    );
  };
  getAll = async (page = 1, searchValue) => {
    return await $apiTelegram.get(
      TELEGRAM_PATH + GET_ALL_USER_PATH + `?page=${page}&search=${searchValue}`,
    );
  };
  getAllMaterialsForProject = async (
    page = 1,
    searchValue,
    projectId = "",
    limit = 10,
  ) => {
    return await $apiTelegram.get(
      TELEGRAM_PATH +
        GET_ALL_MATERIALS_WORK_PATH +
        `?page=${page}&search=${searchValue}&limit=${limit}&projectId=${projectId}`,
    );
  };
  getAllWorks = async (page = 1, searchValue, projectId = "", limit = 30) => {
    return await $apiTelegram.get(
      TELEGRAM_PATH +
        GET_ALL_WORK_PATH +
        `?page=${page}&search=${searchValue}&limit=${limit}&projectId=${projectId}`,
    );
  };
  getSingleBlank = async (projectId, blankId) => {
    return await $apiTelegram.get(
      TELEGRAM_PATH +
        GET_SINGLE_BLANK_TELEGRAM_PATH +
        `?projectId=${projectId}&blankId=${blankId}`,
    );
  };
}

export default new TelegramApi();
